import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { FileText, ArrowRight } from "lucide-react";

export default function InvoicesList() {
  const [vehicles, setVehicles] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/vehicles", { params: { status: "Delivered" } }).then(({ data }) => setVehicles(data));
  }, []);
  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-6">
        <h1 className="font-heading text-3xl font-bold text-slate-900" data-testid="invoices-heading">Invoices</h1>
        <p className="text-sm text-slate-500 mt-1">All invoices for delivered vehicles</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg table-scroll">
        <table className="data-table w-full">
          <thead><tr><th className="col-sr">SR. No.</th><th>Model</th><th>Chassis</th><th>Branch</th><th className="text-right pr-6">Action</th></tr></thead>
          <tbody>
            {vehicles.length === 0 && (
              <tr><td colSpan={5} className="text-center py-10 text-slate-400 text-sm">No invoices yet</td></tr>
            )}
            {vehicles.map((v, idx) => (
              <tr key={v.id} data-testid={`invoice-list-row-${v.id}`}>
                <td className="col-sr">{idx + 1}</td>
                <td className="font-medium text-slate-900">{v.model}</td>
                <td className="font-mono text-xs">{v.chassis_number}</td>
                <td>{v.branch}</td>
                <td className="text-right pr-6">
                  <button data-testid={`open-invoice-${v.id}`}
                    onClick={() => navigate(`/invoice/${v.id}`)}
                    className="inline-flex items-center gap-1 px-3 py-1.5 rounded-md bg-brand-blue bg-brand-blue-hover text-white text-xs">
                    <FileText className="w-3 h-3" /> Open <ArrowRight className="w-3 h-3" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
